module.exports = __webpack_public_path__ + "img/developers-icon-dark.c3504ed2.svg";